/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    getQuoteVariation,
    delQuoteVariation,
    createQuoteVariation,
    issueQuoteVariation,
    updateQuoteVariation,
    updateRenewalVariation,
    bindQuoteVariation,
    checkSoftReferral,
    inviteQuoteVariation,
    renewalBindQuoteVariation,
    getRenewalVariation,
    getAllQuoteVariation,
    fetchTradeFairsLocations,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import VariantionContainer from '../components/VariantionContainer'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        step05: state.step05,
        renewalStep05: state.step05Renewals,
        quoteId: props.quoteId,
        tradeFairsLocations: state.step00.tradeFairsLocations,
    }
}

export default connect(
    mapStateToProps,
    {
        getQuoteVariation: getQuoteVariation,
        delQuoteVariation: delQuoteVariation,
        createQuoteVariation: createQuoteVariation,
        getAllQuoteVariation: getAllQuoteVariation,
        issueQuoteVariation: issueQuoteVariation,
        updateQuoteVariation: updateQuoteVariation,
        updateRenewalVariation: updateRenewalVariation,
        bindQuoteVariation: bindQuoteVariation,
        checkSoftReferral: checkSoftReferral,
        inviteQuoteVariation: inviteQuoteVariation,
        renewalBindQuoteVariation: renewalBindQuoteVariation,
        getRenewalVariation: getRenewalVariation,
        fetchTradeFairsLocations,
    }
)(VariantionContainer)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05d/containers/VariantionContainer.tsx